// extracted by mini-css-extract-plugin
module.exports = {"GalleryImageOverlay":"GalleryItem_GalleryImageOverlay__29dD8","ContentType":"GalleryItem_ContentType__2Lw42","Date":"GalleryItem_Date__29TwM","Author":"GalleryItem_Author__3cSp9"};